import React, { ReactNode, useEffect, useRef } from 'react';
import styles from './styles.module.scss'

interface Props {
    showModal: boolean;
    setShowModal: (val: boolean) => void;
    children: ReactNode;
    asDialogue?: boolean;
    preventClose?: boolean;
}

const ModalFormContainer: React.FC<Props> = ({ showModal, setShowModal, children, asDialogue, preventClose }) => {
    const formDialogueRef = useRef<HTMLDialogElement>(null);

    useEffect(() => {
        if (!preventClose || !showModal) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return () => { };
        }
        const preventEsc = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                e.preventDefault();
            }
        }

        window.addEventListener('keydown', preventEsc);
        return () => {
            window.removeEventListener('keydown', preventEsc)
        }
    }, [preventClose])

    useEffect(() => {
        if (!formDialogueRef.current) return;

        if (asDialogue) {
            if (showModal) {
                formDialogueRef.current.show();
                return
            }

            if (formDialogueRef.current.open) {
                formDialogueRef.current.close()
            }
        } else {
            if (showModal) {
                formDialogueRef.current.showModal();
                return
            }

            if (formDialogueRef.current.open) {
                formDialogueRef.current.close()
            }
        }
    }, [showModal]);

    return (
        <dialog
            ref={formDialogueRef}
            onClose={() => setShowModal(false)}
            onCancel={(e) => {
                if (preventClose) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
            className={styles.form_dialogue}
            data-as-dialogue={asDialogue || null}
        >
            {showModal ? (
                children
            ) : null}
        </dialog>
    );
};

export default ModalFormContainer;
